export default "__VITE_ASSET__Nq1Er_Ch__"